/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserProfile } from './UserProfile';
import { UserProfileFromJSON, UserProfileFromJSONTyped, UserProfileToJSON } from './UserProfile';

/**
 *
 * @export
 * @interface PatchedCalvinUser
 */
export interface PatchedCalvinUser {
  /**
   *
   * @type {number}
   * @memberof PatchedCalvinUser
   */
  readonly id?: number;
  /**
   * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
   * @type {string}
   * @memberof PatchedCalvinUser
   */
  username?: string;
  /**
   *
   * @type {string}
   * @memberof PatchedCalvinUser
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof PatchedCalvinUser
   */
  lastName?: string;
  /**
   *
   * @type {string}
   * @memberof PatchedCalvinUser
   */
  readonly email?: string;
  /**
   *
   * @type {UserProfile}
   * @memberof PatchedCalvinUser
   */
  calvinProfile?: UserProfile;
}

/**
 * Check if a given object implements the PatchedCalvinUser interface.
 */
export function instanceOfPatchedCalvinUser(value: object): value is PatchedCalvinUser {
  return true;
}

export function PatchedCalvinUserFromJSON(json: any): PatchedCalvinUser {
  return PatchedCalvinUserFromJSONTyped(json, false);
}

export function PatchedCalvinUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedCalvinUser {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    username: json['username'] == null ? undefined : json['username'],
    firstName: json['first_name'] == null ? undefined : json['first_name'],
    lastName: json['last_name'] == null ? undefined : json['last_name'],
    email: json['email'] == null ? undefined : json['email'],
    calvinProfile: json['calvin_profile'] == null ? undefined : UserProfileFromJSON(json['calvin_profile']),
  };
}

export function PatchedCalvinUserToJSON(value?: Omit<PatchedCalvinUser, 'id' | 'email'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    username: value['username'],
    first_name: value['firstName'],
    last_name: value['lastName'],
    calvin_profile: UserProfileToJSON(value['calvinProfile']),
  };
}
